import styled from 'styled-components'
import COLORS from '@colors'

export const Main = styled.div`
  font-family: 'Barlow';
  font-size: 14px;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
`

export const MapContainer = styled.div`
  position: absolute;
  top: 64px;
  right: 0;
  bottom: 0;
  left: 0;

  div div div .gm-control-active.gm-fullscreen-control {
    display: none !important;
  }

  .gmnoprint div {
    border-radius: 4px !important;
    position: relative !important;
    right: 300px !important;
    &.gm-svpc {
      border-radius: 4px !important;
      bottom: -32px !important;
      left: unset !important;
      position: relative !important;
      right: 352px !important;
      top: unset !important;
      ${props => props.drawing && 'display: none !important'};
    }
  }

  .gmnoprint,
  button.gm-control-active {
    ${props => props.drawing && 'display: none !important'};
  }
`

export const SearchFilter = styled.div`
  left: ${props => (props.active ? '20px' : '24px')};
  top: ${props => (props.active ? '75px' : '89px')};
  box-shadow: 0 3px 24px #00000029;
  z-index: ${props => (props.active ? 3 : 'auto')};
  display: flex;
  height: 40px;
  position: absolute;
  width: ${props => (props.active ? '296px' : '414px')};
  transition: 0.1s ease;
  border-radius: 0px 4px 4px 0px;
`

export const FilterButton = styled.button`
  background-color: ${props => (props.right ? COLORS.white : COLORS.gray28)};
  border-radius: ${props => (props.right ? '0 4px 4px 0' : '4px 0 0 4px')};
  padding: 8px;
  width: 40px;
  border: 0;
  outline: 0;
  cursor: pointer;
  user-select: none;
  ${props => props.active && 'display: none;'}
`

export const ClearFilters = styled.button`
  background-color: ${COLORS.gray45};
  color: ${COLORS.white};
  height: ${props => (props.filterActive ? '52px' : '40px')};
  width: 100px;
  border: 0;
  outline: 0;
  cursor: pointer;
  user-select: none;
  position: absolute;
  top: ${props => (props.filterActive ? '0' : '89px')};
  right: ${props => (props.filterActive ? '0' : 'unset')};
  ${props =>
    !props.filterActive &&
    `
    left: 450px;
    border-radius: 4px;
  `}
`

export const InputWrapper = styled.div`
  display: flex;
  position: relative;
  width: ${props => (props.active ? '100%' : '374px')};
  border-radius: 4px 4px 4px 4px;
`

export const IconWrapper = styled.div`
  left: 10px;
  position: absolute;
  top: 10px;
`

export const ButtonsContainer = styled.div`
  bottom: 25px;
  display: flex;
  position: absolute;
  right: ${props => (props.drawing ? '12px' : '414px')};
`
export const ButtonContainer = styled.div`
  display: flex;
`
